import React from 'react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useEPeticeEditContext } from '@gov-nx/module/page';
import { Button, ButtonGroupLayout, LayoutGap } from '@gov-nx/ui/web';
import { MarkdownRender } from '../../../Markdown/MarkdownRender';

export const WizardStep3 = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();

	const { code, isProcessing, wizard } = useEPeticeEditContext();
	const tsn = getLocalizeCurried(code);
	return (
		<LayoutGap gap="m">
			<LayoutGap gap="m">
				<MarkdownRender>
					{tsn('formular.popis.informace-pro-zakladatele-podpis')}
				</MarkdownRender>
				<MarkdownRender>
					{tsn('formular.popis.informace-pro-zakladatele')}
				</MarkdownRender>
				<MarkdownRender>
					{tsn('formular.popis.informace-pro-zakladatele-zpracovani-udaju')}
				</MarkdownRender>
			</LayoutGap>
			<ButtonGroupLayout>
				<Button
					onClick={() => wizard.openNextStep(3)}
					isLoading={isProcessing}
					aria-label={tsn('akce.wcag.pokracovat')}
					isDisabled={isProcessing}
					color="primary"
					size="l"
					type="solid">
					{tsn('formular.tlacitko.pokracovat')}
				</Button>
			</ButtonGroupLayout>
		</LayoutGap>
	);
};
